import { ActionsClient } from "./endpoints/actions";
import { AgendaClient } from "./endpoints/agenda";
import { ApiTokensClient } from "./endpoints/api-tokens";
import { Application } from "./endpoints/application";
import { AvigilonClient } from "./endpoints/avigilon";
import { Billing } from "./endpoints/billing";
import { BulkImportsClient } from "./endpoints/bulk-imports";
import { Calendar } from "./endpoints/calendar";
import { CalendarAuth } from "./endpoints/calendar-auth";
import { CoreIntegrations } from "./endpoints/core-integrations";
import { DemoDataClient } from "./endpoints/demo-data";
import { DivisionsClient } from "./endpoints/divisions";
import { Enterprises } from "./endpoints/enterprises";
import { Externals } from "./endpoints/externals";
import { Favorites } from "./endpoints/favorites";
import { Forms } from "./endpoints/forms";
import { Health } from "./endpoints/health";
import { HoursClient } from "./endpoints/hours";
import { Integrations } from "./endpoints/integrations";
import { Invitations } from "./endpoints/invitations";
import { LeaveClient } from "./endpoints/leave";
import { McpClient } from "./endpoints/mcp";
import { MyCalendarClient } from "./endpoints/my-calendar";
import { Notifications } from "./endpoints/notifications";
import { Organizations } from "./endpoints/organizations";
import { Pages } from "./endpoints/pages";
import { PermissionGroupsClient } from "./endpoints/permission-groups";
import { ReportingClient } from "./endpoints/reporting";
import { Reports } from "./endpoints/reports";
import { Schedules } from "./endpoints/schedules";
import { GlobalSearch } from "./endpoints/search";
import { SettingsClient } from "./endpoints/settings";
import { Signatures } from "./endpoints/signatures";
import { Signups } from "./endpoints/signups";
import { Stations } from "./endpoints/stations";
import { TableOverviewClient } from "./endpoints/table-overview";
import { Tags } from "./endpoints/tags";
import { TeamsClient } from "./endpoints/teams";
import { Tessa } from "./endpoints/tessa";
import { Unauthenticated } from "./endpoints/unauthenticated";
import { Uploads } from "./endpoints/uploads";
import { UserSettings } from "./endpoints/user_settings";
import { Users } from "./endpoints/users";
import {
  DeliveriesClient,
  PublicSharingVisitsClient,
  StationSelfClient,
  VisitorDocumentsClient,
  VisitorInvitationsClient,
  VisitorNotificationsClient,
  VisitorSettingsClient,
  VisitorStationsClient,
  VisitorsClient,
  VisitorTypesClient,
  VisitsClient,
  WatchlistClient
} from "./endpoints/visitor-manager";
import { Wifi } from "./endpoints/wifi";
import { WorkplaceRequestCategoriesClient } from "./endpoints/workplace-request-categories";
import { WorkplaceRequestCommentsClient } from "./endpoints/workplace-request-comments";
import { WorkplaceRequestDashboardPublicClient } from "./endpoints/workplace-request-dashboard-public";
import { WorkplaceRequestDashboardsClient } from "./endpoints/workplace-request-dashboards";
import { WorkplaceRequestEventsClient } from "./endpoints/workplace-request-events";
import { WorkplaceRequestSharingClient } from "./endpoints/workplace-request-sharing";
import { WorkplaceRequestTypesClient } from "./endpoints/workplace-request-types";
import { WorkplaceRequestsClient } from "./endpoints/workplace-requests";
import { ZonesClient } from "./endpoints/zones";
import { Settings } from "./settings";

export class Client {
  private readonly settings: Settings;
  public readonly slug: string;
  private healthClient: Health | null = null;
  private leaveClient: LeaveClient | null = null;
  private actionsClient: ActionsClient | null = null;
  private hoursClient: HoursClient | null = null;
  private teamsClient: TeamsClient | null = null;
  private enterprisesClient: Enterprises | null = null;
  private invitationsClient: Invitations | null = null;
  private integrationsClient: Integrations | null = null;
  private externalsClient: Externals | null = null;
  private organizationsClient: Organizations | null = null;
  private tessaClient: Tessa | null = null;
  private reportsClient: Reports | null = null;
  private formsClient: Forms | null = null;
  private schedulesClient: Schedules | null = null;
  private divisionsClient: DivisionsClient | null = null;
  private zonesClient: ZonesClient | null = null;
  private demoDataClient: DemoDataClient | null = null;
  private avigilonClient: AvigilonClient | null = null;
  private coreIntegrationsClient: CoreIntegrations | null = null;
  private stationsClient: Stations | null = null;
  private signupsClient: Signups | null = null;
  private signaturesClient: Signatures | null = null;
  private wifiClient: Wifi | null = null;
  private usersClient: Users | null = null;
  private unauthenticatedClient: Unauthenticated | null = null;
  private applicationClient: Application | null = null;
  private adminSchedulesClient: Schedules | null = null;
  private adminUsersClient: Users | null = null;
  private adminOrganizationsClient: Organizations | null = null;
  private adminLeaveClient: LeaveClient | null = null;
  private adminStationsClient: Stations | null = null;
  private calendarClient: Calendar | null = null;
  private userSettingsClient: UserSettings | null = null;
  private pagesClient: Pages | null = null;
  private tagsClient: Tags | null = null;
  private favoritesClient: Favorites | null = null;
  private uploadsClient: Uploads | null = null;
  private settingsClient: SettingsClient | null = null;
  private agendaClient: AgendaClient | null = null;
  private calendarAuthClient: CalendarAuth | null = null;
  private myCalendarClient: MyCalendarClient | null = null;
  private tableOverviewClient: TableOverviewClient | null = null;
  private workplaceRequestsClient: WorkplaceRequestsClient | null = null;
  private reportingClient: ReportingClient | null = null;
  private workplaceRequestTypesClient: WorkplaceRequestTypesClient | null =
    null;
  private workplaceRequestCommentsClient: WorkplaceRequestCommentsClient | null =
    null;
  private workplaceRequestSharingClient: WorkplaceRequestSharingClient | null =
    null;
  private workplaceRequestEventsClient: WorkplaceRequestEventsClient | null =
    null;
  private workplaceRequestCategoriesClient: WorkplaceRequestCategoriesClient | null =
    null;
  private workplaceRequestDashboardsClient: WorkplaceRequestDashboardsClient | null =
    null;
  private workplaceRequestDashboardPublicClient: WorkplaceRequestDashboardPublicClient | null =
    null;
  private globalSearchClient: GlobalSearch | null = null;
  private billingClient: Billing | null = null;
  private visitorDocumentsClient: VisitorDocumentsClient | null = null;
  private visitorTypesClient: VisitorTypesClient | null = null;
  private visitorStationsClient: VisitorStationsClient | null = null;
  private watchlistClient: WatchlistClient | null = null;
  private visitorSettingsClient: VisitorSettingsClient | null = null;
  private visitsClient: VisitsClient | null = null;
  private visitorsClient: VisitorsClient | null = null;
  private stationSelfClient: StationSelfClient | null = null;
  private visitorInvitationsClient: VisitorInvitationsClient | null = null;
  private deliveriesClient: DeliveriesClient | null = null;
  private visitorNotificationsClient: VisitorNotificationsClient | null = null;
  private publicSharingVisitsClient: PublicSharingVisitsClient | null = null;
  private notificationsClient: Notifications | null = null;
  private apiTokensClient: ApiTokensClient | null = null;
  private mcpClient: McpClient | null = null;
  private bulkImportsClient: BulkImportsClient | null = null;
  private permissionGroupsClient: PermissionGroupsClient | null = null;

  constructor(settings: Settings) {
    this.settings = settings;
    this.slug = settings.slug ?? "";
  }

  get enterprises(): Enterprises {
    if (this.enterprisesClient === null) {
      this.checkAccess();
      this.enterprisesClient = new Enterprises(this.settings, this.slug);
    }
    return this.enterprisesClient;
  }

  get invitations(): Invitations {
    if (this.invitationsClient === null) {
      this.checkAccess();
      this.invitationsClient = new Invitations(this.settings, this.slug);
    }
    return this.invitationsClient;
  }

  get organizations(): Organizations {
    if (this.organizationsClient === null) {
      this.checkAccess();
      this.organizationsClient = new Organizations(this.settings, this.slug);
    }
    return this.organizationsClient;
  }

  get tessa(): Tessa {
    if (this.tessaClient === null) {
      this.checkAccess();
      this.tessaClient = new Tessa(this.settings, this.slug);
    }

    return this.tessaClient;
  }

  get adminOrganizations(): Organizations {
    if (this.adminOrganizationsClient === null) {
      this.adminOrganizationsClient = new Organizations(this.settings, null);
    }
    return this.adminOrganizationsClient;
  }

  get pages(): Pages {
    if (this.pagesClient === null) {
      this.checkAccess();
      this.pagesClient = new Pages(this.settings, this.slug);
    }
    return this.pagesClient;
  }

  get tags(): Tags {
    if (this.tagsClient === null) {
      this.checkAccess();
      this.tagsClient = new Tags(this.settings, this.slug);
    }
    return this.tagsClient;
  }

  get favorites(): Favorites {
    if (this.favoritesClient === null) {
      this.checkAccess();
      this.favoritesClient = new Favorites(this.settings, this.slug);
    }
    return this.favoritesClient;
  }

  get uploads(): Uploads {
    if (this.uploadsClient === null) {
      this.checkAccess();
      this.uploadsClient = new Uploads(this.settings);
    }
    return this.uploadsClient;
  }

  get reports(): Reports {
    if (this.reportsClient === null) {
      this.checkAccess();
      this.reportsClient = new Reports(this.settings, this.slug);
    }
    return this.reportsClient;
  }

  get forms(): Forms {
    if (this.formsClient === null) {
      this.checkAccess();
      this.formsClient = new Forms(this.settings, this.slug);
    }
    return this.formsClient;
  }

  get integrations(): Integrations {
    if (this.integrationsClient === null) {
      this.checkAccess();
      this.integrationsClient = new Integrations(this.settings, this.slug);
    }
    return this.integrationsClient;
  }

  get externals(): Externals {
    if (this.externalsClient === null) {
      this.checkAccess();
      this.externalsClient = new Externals(this.settings, this.slug);
    }
    return this.externalsClient;
  }

  get schedules(): Schedules {
    if (this.schedulesClient === null) {
      this.checkAccess();
      this.schedulesClient = new Schedules(this.settings, this.slug);
    }
    return this.schedulesClient;
  }

  get stations(): Stations {
    if (this.stationsClient === null) {
      this.checkAccess();
      this.stationsClient = new Stations(this.settings, this.slug);
    }
    return this.stationsClient;
  }

  get adminStations(): Stations {
    if (this.adminStationsClient === null) {
      this.adminStationsClient = new Stations(this.settings, null);
    }
    return this.adminStationsClient;
  }

  get adminSchedules(): Schedules {
    if (this.adminSchedulesClient === null) {
      this.adminSchedulesClient = new Schedules(this.settings, null);
    }
    return this.adminSchedulesClient;
  }

  get signatures(): Signatures {
    if (this.signaturesClient === null) {
      this.checkAccess();
      this.signaturesClient = new Signatures(this.settings, this.slug);
    }
    return this.signaturesClient;
  }

  get signups(): Signups {
    if (this.signupsClient === null) {
      this.signupsClient = new Signups(this.settings);
    }
    return this.signupsClient;
  }

  get wifi(): Wifi {
    if (this.wifiClient === null) {
      this.checkAccess();
      this.wifiClient = new Wifi(this.settings, this.slug);
    }
    return this.wifiClient;
  }

  get health(): Health {
    if (this.healthClient === null) {
      this.checkAccess();
      this.healthClient = new Health(this.settings, this.slug);
    }
    return this.healthClient;
  }

  get leave(): LeaveClient {
    if (this.leaveClient === null) {
      this.checkAccess();
      this.leaveClient = new LeaveClient(this.settings, this.slug);
    }
    return this.leaveClient;
  }

  get divisions(): DivisionsClient {
    if (this.divisionsClient === null) {
      this.checkAccess();
      this.divisionsClient = new DivisionsClient(this.settings, this.slug);
    }
    return this.divisionsClient;
  }

  get zones(): ZonesClient {
    if (this.zonesClient === null) {
      this.checkAccess();
      this.zonesClient = new ZonesClient(this.settings, this.slug);
    }
    return this.zonesClient;
  }

  get demoData(): DemoDataClient {
    if (this.demoDataClient === null) {
      this.checkAccess();
      this.demoDataClient = new DemoDataClient(this.settings, this.slug);
    }
    return this.demoDataClient;
  }

  get coreIntegrations(): CoreIntegrations {
    if (this.coreIntegrationsClient === null) {
      this.checkAccess();
      this.coreIntegrationsClient = new CoreIntegrations(
        this.settings,
        this.slug
      );
    }
    return this.coreIntegrationsClient;
  }

  get avigilon(): AvigilonClient {
    if (this.avigilonClient === null) {
      this.checkAccess();
      this.avigilonClient = new AvigilonClient(this.settings, this.slug);
    }
    return this.avigilonClient;
  }

  get adminLeave(): LeaveClient {
    if (this.adminLeaveClient === null) {
      this.adminLeaveClient = new LeaveClient(this.settings, null);
    }
    return this.adminLeaveClient;
  }

  get actions(): ActionsClient {
    if (this.actionsClient === null) {
      this.checkAccess();
      this.actionsClient = new ActionsClient(this.settings, this.slug);
    }
    return this.actionsClient;
  }

  get hours(): HoursClient {
    if (this.hoursClient === null) {
      this.checkAccess();
      this.hoursClient = new HoursClient(this.settings, this.slug);
    }
    return this.hoursClient;
  }

  get teams(): TeamsClient {
    if (this.teamsClient === null) {
      this.checkAccess();
      this.teamsClient = new TeamsClient(this.settings, this.slug);
    }
    return this.teamsClient;
  }

  get users(): Users {
    this.checkAccess(false);
    if (this.usersClient === null) {
      this.usersClient = new Users(this.settings);
    }
    return this.usersClient;
  }

  get adminUsers(): Users {
    if (this.adminUsersClient === null) {
      this.adminUsersClient = new Users(this.settings);
    }
    return this.adminUsersClient;
  }

  get unauthenticated(): Unauthenticated {
    if (this.unauthenticatedClient === null) {
      this.unauthenticatedClient = new Unauthenticated(this.settings, null);
    }
    return this.unauthenticatedClient;
  }

  get application(): Application {
    if (this.applicationClient === null) {
      this.checkAccess();
      this.applicationClient = new Application(this.settings, this.slug);
    }
    return this.applicationClient;
  }

  get calendar(): Calendar {
    if (this.calendarClient === null) {
      this.calendarClient = new Calendar(this.settings, this.slug);
    }
    return this.calendarClient;
  }

  get calendarAuth(): CalendarAuth {
    if (this.calendarAuthClient === null) {
      this.calendarAuthClient = new CalendarAuth(this.settings, this.slug);
    }
    return this.calendarAuthClient;
  }

  get userSettings(): UserSettings {
    if (this.userSettingsClient === null) {
      this.userSettingsClient = new UserSettings(this.settings, this.slug);
    }
    return this.userSettingsClient;
  }

  private checkAccess(withSlug = true): void {
    if (withSlug && this.slug === null) {
      throw new Error("Missing slug");
    }
  }

  get orgOrOfficeSettings(): SettingsClient {
    if (this.settingsClient === null) {
      this.settingsClient = new SettingsClient(this.settings, this.slug);
    }
    return this.settingsClient;
  }

  get agenda(): AgendaClient {
    if (this.agendaClient === null) {
      this.agendaClient = new AgendaClient(this.settings, this.slug);
    }
    return this.agendaClient;
  }

  get myCalendar(): MyCalendarClient {
    if (this.myCalendarClient === null) {
      this.myCalendarClient = new MyCalendarClient(this.settings, this.slug);
    }
    return this.myCalendarClient;
  }

  get tableOverview(): TableOverviewClient {
    if (this.tableOverviewClient === null) {
      this.tableOverviewClient = new TableOverviewClient(
        this.settings,
        this.slug
      );
    }
    return this.tableOverviewClient;
  }

  get workplaceRequests(): WorkplaceRequestsClient {
    if (this.workplaceRequestsClient === null) {
      this.workplaceRequestsClient = new WorkplaceRequestsClient(
        this.settings,
        this.slug
      );
    }
    return this.workplaceRequestsClient;
  }

  get reporting(): ReportingClient {
    if (this.reportingClient === null) {
      this.reportingClient = new ReportingClient(this.settings, this.slug);
    }
    return this.reportingClient;
  }

  get workplaceRequestTypes(): WorkplaceRequestTypesClient {
    if (this.workplaceRequestTypesClient === null) {
      this.workplaceRequestTypesClient = new WorkplaceRequestTypesClient(
        this.settings,
        this.slug
      );
    }
    return this.workplaceRequestTypesClient;
  }

  get workplaceRequestComments(): WorkplaceRequestCommentsClient {
    if (this.workplaceRequestCommentsClient === null) {
      this.workplaceRequestCommentsClient = new WorkplaceRequestCommentsClient(
        this.settings,
        this.slug
      );
    }
    return this.workplaceRequestCommentsClient;
  }

  get workplaceRequestSharing(): WorkplaceRequestSharingClient {
    if (this.workplaceRequestSharingClient === null) {
      this.workplaceRequestSharingClient = new WorkplaceRequestSharingClient(
        this.settings,
        this.slug
      );
    }
    return this.workplaceRequestSharingClient;
  }

  get workplaceRequestDashboards(): WorkplaceRequestDashboardsClient {
    if (this.workplaceRequestDashboardsClient === null) {
      this.workplaceRequestDashboardsClient =
        new WorkplaceRequestDashboardsClient(this.settings, this.slug);
    }
    return this.workplaceRequestDashboardsClient;
  }

  get workplaceRequestDashboardPublic(): WorkplaceRequestDashboardPublicClient {
    if (this.workplaceRequestDashboardPublicClient === null) {
      this.workplaceRequestDashboardPublicClient =
        new WorkplaceRequestDashboardPublicClient(this.settings, this.slug);
    }
    return this.workplaceRequestDashboardPublicClient;
  }

  get workplaceRequestEvents(): WorkplaceRequestEventsClient {
    if (this.workplaceRequestEventsClient === null) {
      this.workplaceRequestEventsClient = new WorkplaceRequestEventsClient(
        this.settings,
        this.slug
      );
    }
    return this.workplaceRequestEventsClient;
  }

  get workplaceRequestCategories(): WorkplaceRequestCategoriesClient {
    if (this.workplaceRequestCategoriesClient === null) {
      this.workplaceRequestCategoriesClient =
        new WorkplaceRequestCategoriesClient(this.settings, this.slug);
    }
    return this.workplaceRequestCategoriesClient;
  }

  get globalSearch(): GlobalSearch {
    if (this.globalSearchClient === null) {
      this.checkAccess();
      this.globalSearchClient = new GlobalSearch(this.settings, this.slug);
    }
    return this.globalSearchClient;
  }

  get billing(): Billing {
    if (this.billingClient === null) {
      this.checkAccess();
      this.billingClient = new Billing(this.settings, this.slug);
    }
    return this.billingClient;
  }

  get visitorDocuments(): VisitorDocumentsClient {
    if (this.visitorDocumentsClient === null) {
      this.checkAccess();
      this.visitorDocumentsClient = new VisitorDocumentsClient(
        this.settings,
        this.slug
      );
    }
    return this.visitorDocumentsClient;
  }

  get visitorTypes(): VisitorTypesClient {
    if (this.visitorTypesClient === null) {
      this.checkAccess();
      this.visitorTypesClient = new VisitorTypesClient(
        this.settings,
        this.slug
      );
    }
    return this.visitorTypesClient;
  }

  get visitorStations(): VisitorStationsClient {
    if (this.visitorStationsClient === null) {
      this.checkAccess();
      this.visitorStationsClient = new VisitorStationsClient(
        this.settings,
        this.slug
      );
    }
    return this.visitorStationsClient;
  }

  get watchlist(): WatchlistClient {
    if (this.watchlistClient === null) {
      this.checkAccess();
      this.watchlistClient = new WatchlistClient(this.settings, this.slug);
    }
    return this.watchlistClient;
  }

  get visitorSettings(): VisitorSettingsClient {
    if (this.visitorSettingsClient === null) {
      this.checkAccess();
      this.visitorSettingsClient = new VisitorSettingsClient(
        this.settings,
        this.slug
      );
    }
    return this.visitorSettingsClient;
  }

  get visits(): VisitsClient {
    if (this.visitsClient === null) {
      this.checkAccess();
      this.visitsClient = new VisitsClient(this.settings, this.slug);
    }
    return this.visitsClient;
  }

  get visitors(): VisitorsClient {
    if (this.visitorsClient === null) {
      this.checkAccess();
      this.visitorsClient = new VisitorsClient(this.settings, this.slug);
    }
    return this.visitorsClient;
  }

  get stationSelf(): StationSelfClient {
    if (this.stationSelfClient === null) {
      this.stationSelfClient = new StationSelfClient(this.settings, this.slug);
    }
    return this.stationSelfClient;
  }

  get visitorInvitations(): VisitorInvitationsClient {
    if (this.visitorInvitationsClient === null) {
      this.visitorInvitationsClient = new VisitorInvitationsClient(
        this.settings,
        this.slug
      );
    }
    return this.visitorInvitationsClient;
  }

  get deliveries(): DeliveriesClient {
    if (this.deliveriesClient === null) {
      this.checkAccess();
      this.deliveriesClient = new DeliveriesClient(this.settings, this.slug);
    }
    return this.deliveriesClient;
  }

  get publicSharingVisits(): PublicSharingVisitsClient {
    if (this.publicSharingVisitsClient === null) {
      this.publicSharingVisitsClient = new PublicSharingVisitsClient(
        this.settings,
        this.slug
      );
    }
    return this.publicSharingVisitsClient;
  }

  get visitorNotifications(): VisitorNotificationsClient {
    if (this.visitorNotificationsClient === null) {
      this.checkAccess();
      this.visitorNotificationsClient = new VisitorNotificationsClient(
        this.settings,
        this.slug
      );
    }
    return this.visitorNotificationsClient;
  }

  get apiTokens(): ApiTokensClient {
    if (this.apiTokensClient === null) {
      this.checkAccess();
      this.apiTokensClient = new ApiTokensClient(this.settings, this.slug);
    }
    return this.apiTokensClient;
  }

  get mcp(): McpClient {
    if (this.mcpClient === null) {
      this.checkAccess();
      this.mcpClient = new McpClient(this.settings, this.slug);
    }
    return this.mcpClient;
  }

  get notifications(): Notifications {
    if (this.notificationsClient === null) {
      this.checkAccess();
      this.notificationsClient = new Notifications(this.settings, this.slug);
    }
    return this.notificationsClient;
  }

  get bulkImports(): BulkImportsClient {
    if (this.bulkImportsClient === null) {
      this.checkAccess();
      this.bulkImportsClient = new BulkImportsClient(this.settings, this.slug);
    }
    return this.bulkImportsClient;
  }

  get permissionGroups(): PermissionGroupsClient {
    if (this.permissionGroupsClient === null) {
      this.checkAccess();
      this.permissionGroupsClient = new PermissionGroupsClient(
        this.settings,
        this.slug
      );
    }
    return this.permissionGroupsClient;
  }
}
